export default class FichaRegistroService {
  constructor(http) {
    this._http = http
  }

  async getDadosPessoais(cpf) {
    const { data } = await this._http.get(
      `/api/ficha-registro/dados-pessoais/${cpf}`,
    )
    return data
  }

  async getHistoricoFuncao(cpf) {
    const { data } = await this._http.get(
      `/api/ficha-registro/historico-funcao/${cpf}`,
    )
    return data
  }

  async getHistoricoFerias(cpf) {
    const { data } = await this._http.get(
      `/api/ficha-registro/historico-ferias/${cpf}`,
    )
    return data
  }

  async getHistoricoEndereco(cpf) {
    const { data } = await this._http.get(
      `/api/ficha-registro/historico-endereco/${cpf}`,
    )
    return data
  }

  async getDependentes(cpf) {
    const { data } = await this._http.get(
      `/api/ficha-registro/dependentes/${cpf}`,
    )
    return data
  }

  async getHistoricoSalarial(cpf) {
    const { data } = await this._http.get(
      `/api/ficha-registro/historico-salarial/${cpf}`,
    )
    return data
  }

  async getAfastamentos(cpf) {
    const { data } = await this._http.get(
      `/api/ficha-registro/afastamentos/${cpf}`,
    )
    return data
  }
}
